import React, {useState, useEffect} from 'react';
import AgentUnitPriceField from "./AgentUnitPriceField";
import AgentPercentDiscountField from "./AgentPercentDiscountField";
import CatchErrors from "../../../Utility/CatchErrors";

export default function AgentPriceEditor({
  item, shoppingCart, currentAgent, callbacks}) {

  window.APE_ITEM = item;

  const {cataloguePrice, regularUnitPrice, privateCeilingPercent  } = item;

  const [agentUnitPrice, setAgentUnitPrice] = useState(item.agentUnitPrice);

  const [violated, setViolated] = useState(false);

  useEffect(() => {
    let newPrice = item.agentUnitPrice;
    if (newPrice !== agentUnitPrice)
      setAgentUnitPrice(newPrice);
  }, [item]);

  function handleCommitChanges() {

    let value = agentUnitPrice ? agentUnitPrice : null;

    console.log(`AgentPriceAssist.save - AUP=${agentUnitPrice}, save as ${value}`);

    callbacks.updateItem({
      id: item.id,
      changes: {agentUnitPrice: value}
    });
  }

  function updateUnitPrice(newUnitPrice) {
    console.log(`UPDATE UNIT PRICE - ${newUnitPrice}`);
    setAgentUnitPrice(newUnitPrice);
  }

  return (
    <CatchErrors>
      <AgentPercentDiscountField
        item={item}
        agentUnitPrice={agentUnitPrice}
        updateUnitPrice={updateUnitPrice}
        commitChanges={handleCommitChanges}
        violated={violated}
        readOnly={shoppingCart.readonly}
        />

      <AgentUnitPriceField
        item={item}
        agentUnitPrice={agentUnitPrice}
        updateUnitPrice={updateUnitPrice}
        commitChanges={handleCommitChanges}
        violated={violated}
        readOnly={shoppingCart.readonly}
        />
    </CatchErrors>

  );
}
